import axios from 'axios';

import { headers, journalServiceUrl } from '../../config';

export function getDpk() {
    return axios.get(`${journalServiceUrl}/dpk`, { headers: headers() });
}